import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';

export default ({ title, reqs, classes, showAlert, borderLeftStyle }) => (
  <Table
    className={classes.tbl}
    style={{
      borderLeft: borderLeftStyle,
      backgroundColor: showAlert ? '#EDC5C3' : '#fff',
    }}
  >
    <TableBody>
      <TableRow>
        <TableCell className={classes.tCellTitle}>{title}</TableCell>
        <TableCell
          className={`${classes.tCellTitle} ${classes.textCenter}`}
          style={{ whiteSpace: 'nowrap' }}
        >
          reqs/avg per hour
        </TableCell>
        <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>min</TableCell>
        <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>avg</TableCell>
        <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>max</TableCell>
      </TableRow>

      {reqs.reqs && Object.values(reqs.reqs).map((req, indexEl) => {
        return (
          <TableRow className={classes.tRow} key={indexEl}>
            <TableCell className={classes.tCellTitle} style={{ width: '300px' }}>{req[0]}</TableCell>
            <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{req[1]}</TableCell>
            <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{req[2]}</TableCell>
            <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{req[3]}</TableCell>
            <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{req[4]}</TableCell>
          </TableRow>
        );
      })}

      <TableRow className={classes.tRow}>
        <TableCell className={classes.tCellTitle}> </TableCell>
        <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{reqs.total_reqs}</TableCell>
        <TableCell className={`${classes.tCell} ${classes.textCenter}`}> </TableCell>
        <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{reqs.total_time}</TableCell>
        <TableCell className={`${classes.tCell} ${classes.textCenter}`}> </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);
